import {
  Component,
  Input,
  ChangeDetectorRef,
  Output,
  EventEmitter,
  SimpleChanges,
  OnInit,
} from '@angular/core';
import { Usuario } from '../../../../../interfaces/usuario/usuario.interface';
import { PermissaoService } from '../../../../../services/permissao.service';
import { AuthService } from '../../../../../services/auth.service';
import { EnumPermissao } from '../../../../../enums/permissoes.enum';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../../../../services/usuario.service';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
@Component({
  selector: 'app-modal-usuario',
  templateUrl: './modal-usuario.component.html',
  styleUrls: ['./modal-usuario.component.css'],
  standalone: false,
})
export class ModalUsuarioComponent implements OnInit {
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    public permissaoService: PermissaoService,
    private authService: AuthService,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private fb: FormBuilder
  ) {}
  mostrarDefinirDiasModal: boolean = false;
  diasDefinidos: number = 30;
  dataAtual: string = '';
  emailOriginal: string = '';
  usuarioForm!: FormGroup;
  @Input() mostrarModal: boolean = false;
  @Output() fecharModal = new EventEmitter<void>();
  @Output() usuarioSalvo = new EventEmitter<void>();
  @Input() usuario?: Usuario | null = {
    idUsuario: 0,
    idCliente: 0,
    login: '',
    nome: '',
    email: '',
    dataExpiracao: new Date(),
    ativo: false,
    acessoCelular: false,
    acessoSimultaneo: false,
    limiteContatos: 0,
    permissoes: [],
    senha: '',
    dataCriacao: new Date(),
    master: false,
    loginPorEmail: false,
    temPermissoes: false,
  };

  salvandoUsuario: boolean = false;
  confirmarSenha: string = '';
  emailInvalido: boolean = false;
  validandoEmail: boolean = false;
  isNovoUsuario: boolean = false;

  ngOnInit(): void {
    this.inicializarFormulario();
    this.definirDataAtual();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['mostrarModal'] && changes['mostrarModal'].currentValue) || (changes['usuario'] && changes['usuario'].currentValue)) {
      this.inicializarFormulario();
      this.emailInvalido = false;
      this.validandoEmail = false;
    
      this.inicializarFormulario();
    }
  }
  obterDataAtual(formato: string, data?: Date): string {
    const dataAtual = data || new Date();
    const ano = dataAtual.getFullYear();
    const mes = (dataAtual.getMonth() + 1).toString().padStart(2, '0');
    const dia = dataAtual.getDate().toString().padStart(2, '0');

    if (formato === 'dd/mm/yyyy') {
      return `${dia}/${mes}/${ano}`;
    } else if (formato === 'yyyy-mm-dd') {
      return `${ano}-${mes}-${dia}`;
    } else {
      return `${dia}/${mes}/${ano}`;
    }
  }

  definirDataAtual(): void {
    this.dataAtual = this.obterDataAtual('yyyy-mm-dd');
  }

  inicializarFormulario(): void {
    this.isNovoUsuario = this.usuario ? false : true;  
    this.emailOriginal = this.usuario?.email || '';
    
    const temDataExpiracao = this.usuario?.dataExpiracao && new Date(this.usuario.dataExpiracao).getTime() > 0;
    let dataFormatada = null;
    if (temDataExpiracao) {
      const data = new Date(this.usuario!.dataExpiracao);
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, '0');
      const dia = String(data.getDate()).padStart(2, '0');
      dataFormatada = `${ano}-${mes}-${dia}`;
    }

    this.usuarioForm = this.fb.group(
      {
        login: [this.usuario?.login || '', [Validators.required, Validators.minLength(3)]],
        nome: [this.usuario?.nome || '', [Validators.required, Validators.minLength(3)]],
        email: [
          this.usuario?.email || '', 
          [
            Validators.required, 
            Validators.email, 
            this.validarEmailCompleto()
          ]
        ],
        senha: ['', this.isNovoUsuario ? [Validators.required, Validators.minLength(6)] : []],
        confirmarSenha: ['', this.isNovoUsuario ? [Validators.required] : []],
        ativo: this.isNovoUsuario ? true : [this.usuario?.ativo || false],
        acessoCelular: [this.usuario?.acessoCelular || false],
        acessoSimultaneo: [this.usuario?.acessoSimultaneo || false],
        acessoExpira: [temDataExpiracao],
        dataExpiracao: [
          { value: dataFormatada, disabled: !temDataExpiracao },
          [Validators.required, this.validarDataExpiracao()],
        ],
        limiteContatos: [this.usuario?.limiteContatos || 0, [Validators.required, Validators.min(0)]],
      },
      { validators: this.validarSenha(this.isNovoUsuario) }
    );

    this.usuarioForm.get('acessoExpira')?.valueChanges.subscribe((checked: boolean) => {
      const dataExpiracaoControl = this.usuarioForm.get('dataExpiracao');
      if (checked) {
        dataExpiracaoControl?.enable();
      } else {
        dataExpiracaoControl?.disable();
        dataExpiracaoControl?.reset();
      }
    });
  }

  validarSenha(isNovoUsuario: boolean): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const senha = group.get('senha')?.value;
      const confirmarSenha = group.get('confirmarSenha')?.value;

      const senhaRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;

      if (isNovoUsuario) {
        if (!senha || !confirmarSenha) {
          return { senhaObrigatoria: true };
        }
        if (!senhaRegex.test(senha)) {
          return { senhaInvalida: true };
        }
        if (senha !== confirmarSenha) {
          return { senhasNaoConferem: true };
        }
      } else {
        if (senha && !senhaRegex.test(senha)) {
          return { senhaInvalida: true };
        }
        if (senha && senha !== confirmarSenha) {
          return { senhasNaoConferem: true };
        }
      }

      return null;
    };
  }

  validarEmailCompleto(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;      
      return emailRegex.test(control.value) ? null : { emailInvalido: true };
    };
  }

  async salvarUsuario(): Promise<void> {
    if (!this.usuarioForm || this.usuarioForm.invalid) {
      this.exibirMensagensErro();
      return;
    }
  
    if (
      !this.permissaoService.hasPermission(EnumPermissao.CriarNovosUsuarios)
    ) {
      this.toastr.error('Você não tem permissão para criar ou editar usuários.');
      return;
    }
  
    this.salvandoUsuario = true;
    const usuario: Usuario = {
      ...this.usuarioForm.value,
      idUsuario: this.usuario?.idUsuario, 
      idCliente: this.authService.getIdCliente(),
    };
  
    try {
      const response = await this.usuarioService.salvarUsuario(usuario);
      if(response.includes('Dados salvos com sucesso')){
        this.toastr.success(
          !this.usuario ? 'Usuário criado com sucesso!' : 'Usuário editado com sucesso!'
        );
      }
      else {
        this.toastr.warning(response);
      }

      this.usuarioForm.reset();
      this.fechar();
      this.usuarioSalvo.emit();
    } 
    catch (error) {
      if (error instanceof Object && error.toString().includes('Já existe usuário com login por email com este email!'))
      {
        this.usuarioForm.patchValue({ ativo: false });
      }
    }
    finally {
      this.salvandoUsuario = false;
    }
  }

  toggleVisualizarSenha(inputId: string): void {
    const input = document.getElementById(inputId) as HTMLInputElement;
    if (input) {
      input.type = input.type === 'password' ? 'text' : 'password';
    }
  }

  fechar(): void {
    this.usuarioForm.reset({
      login: '',
      nome: '',
      email: '',
      senha: '',
      confirmarSenha: '',
      ativo: this.isNovoUsuario ? true : false,
      acessoCelular: false,
      acessoSimultaneo: false,
      acessoExpira: false,
      dataExpiracao: { value: null, disabled: true },
      limiteContatos: 0
    });
    
    this.usuarioForm.markAsPristine();
    this.usuarioForm.markAsUntouched();
    Object.keys(this.usuarioForm.controls).forEach(key => {
      const control = this.usuarioForm.get(key);
      control?.markAsPristine();
      control?.markAsUntouched();
    });
    
    this.emailInvalido = false;
    this.validandoEmail = false;
    
    this.mostrarModal = false;
    this.fecharModal.emit();
    
    const senhaInput = document.getElementById('password') as HTMLInputElement;
    const confirmarSenhaInput = document.getElementById(
      'repeat-password'
    ) as HTMLInputElement;

    if (senhaInput) {
      senhaInput.type = 'password';
    }
    if (confirmarSenhaInput) {
      confirmarSenhaInput.type = 'password';
    }
    
    this.changeDetectorRef.detectChanges();
  }

  onInputEmail(event: any): void {
    const valor = event.target.value;
    this.usuarioForm.patchValue({ email: valor, login: valor });
  }

  async validarEmail(): Promise<void> {
    const email = this.usuarioForm.get('email')?.value;

    if (!email) {
      return;
    }

    if (!this.isNovoUsuario && email === this.emailOriginal) {
      this.emailInvalido = false;
      return;
    }

    this.validandoEmail = true;
    const idUsuarioLogado = this.authService.getIdUsuarioLogado();
    const resultado = await this.usuarioService.verificarEmailExistente(
      email,
      idUsuarioLogado
    );

    if (!resultado) {
      this.emailInvalido = true;
      this.toastr.error(
        'Este e-mail já está em uso. Por favor, escolha outro.'
      );
    } else {
      this.emailInvalido = false;
    }

    this.validandoEmail = false;
  }

  validarDataExpiracao(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const form = control.parent;
      if (!form) return null;
      
      const acessoExpira = form.get('acessoExpira')?.value;
      const dataAtual = new Date();
      const dataExpiracao = control.value ? new Date(control.value) : null;

      if (dataExpiracao && dataExpiracao < dataAtual) {
        return { dataInvalida: true };
      }
      
      if (acessoExpira && !control.value) {
        return { dataRequerida: true };
      }

      return null;
    };
  }

  exibirMensagensErro(): void {
    const controls = this.usuarioForm.controls;

    if (controls['login']?.hasError('required')) {
      this.toastr.error('O campo "Login" é obrigatório.');
    }
    if (controls['login']?.hasError('minlength')) {
      this.toastr.error('O campo "Login" deve ter pelo menos 3 caracteres.');
    }

    if (controls['nome']?.hasError('required')) {
      this.toastr.error('O campo "Nome" é obrigatório.');
    }
    if (controls['nome']?.hasError('minlength')) {
      this.toastr.error('O campo "Nome" deve ter pelo menos 3 caracteres.');
    }

    if (controls['email']?.hasError('required')) {
      this.toastr.error('O campo "E-mail" é obrigatório.');
    }
    if (controls['email']?.hasError('email') || controls['email']?.hasError('emailInvalido')) {
      this.toastr.error('Insira um e-mail válido.');
    }
    if (this.emailInvalido) {
      this.toastr.error(
        'Este e-mail já está em uso. Por favor, escolha outro.'
      );
    }
    if (controls['dataExpiracao']?.hasError('dataInvalida')) {
      this.toastr.error(
        'A data de expiração não pode ser menor que a data atual.'
      );
    }
    if (controls['dataExpiracao']?.hasError('dataRequerida')) {
      this.toastr.error(
        'A data de expiração é obrigatória quando "Acesso Expira" está ativado.'
      );
    }
    if (this.usuarioForm.hasError('senhaObrigatoria')) {
      this.toastr.error(
        'Os campos "Senha" e "Confirmação de Senha" são obrigatórios.'
      );
    }
    if (this.usuarioForm.hasError('senhaInvalida')) {
      this.toastr.error(
        'A senha deve ter pelo menos 6 caracteres, uma letra maiúscula, uma minúscula e um caractere especial.'
      );
    }
    if (this.usuarioForm.hasError('senhasNaoConferem')) {
      this.toastr.error('As senhas não conferem.');
    }
  }

  abrirDefinirDiasModal(): void {
    this.mostrarModal = false;
    this.mostrarDefinirDiasModal = true;
    this.changeDetectorRef.detectChanges();
  }

  fecharDefinirDiasModal(): void {
    this.emailInvalido = false;
    this.validandoEmail = false;
    this.mostrarDefinirDiasModal = false;
    this.mostrarModal = true;
    this.changeDetectorRef.detectChanges();
  }

  aplicarDias(): void {
    const dataAtual = new Date();
    const novaData = new Date(
      dataAtual.setDate(dataAtual.getDate() + this.diasDefinidos)
    );
    const ano = novaData.getFullYear();
    const mes = (novaData.getMonth() + 1).toString().padStart(2, '0');
    const dia = novaData.getDate().toString().padStart(2, '0');

    const dataFormatada = this.obterDataAtual('yyyy-mm-dd', novaData);

    this.usuarioForm.patchValue({ dataExpiracao: dataFormatada });

    this.fecharDefinirDiasModal();
  }

  calcularDataResultante(): string {
    if (!this.diasDefinidos) {
      return '';
    }
    const resultDate = new Date(
      Date.now() + this.diasDefinidos * 24 * 60 * 60 * 1000
    );
    return resultDate.toLocaleDateString();
  }
}
